<template>
    <div class="tabs-container">
        <DxTabs :data-source="tabs" v-model:selected-index="selectedIndex" :item-template="tabTemplate" />
        <div v-if="selectedIndex === 0">
            <GridTabCampanii @select-campaign="onCampaignSelected" />
        </div>
        <div v-if="selectedIndex === 1">
            <GridCampaniiDetalii :campaign="selectedCampaign" @back="selectedIndex = 0" />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { DxTabs } from 'devextreme-vue/tabs';
import GridTabCampanii from './GridTabCampanii.vue';
import GridCampaniiDetalii from './GridCampaniiDetalii.vue';
import CrmCampaniiMarketing from '@/services/Comercial/CrmCampaniiMarketing';
import DataSource from 'devextreme/data/data_source';
import AppSetting from '@/settings/appSettings';

export default defineComponent({
    components: {
        DxTabs,
        GridTabCampanii,
        GridCampaniiDetalii
    },
    data() {
        return {
            tabs: [
                { text: 'Campanii' },
                { text: 'Detalii' },
            ],
            selectedIndex: 0,
            selectedCampaign: null
        };
    },
    mounted() {
        // Handled by query watcher with immediate: true
    },
    watch: {
        '$route.query.campaignId': {
            handler(newId) {
                if (newId) {
                    this.fetchCampaign(newId as string);
                }
            },
            immediate: true
        }
    },
    methods: {
        tabTemplate(itemData: any) {
            return `<div>${itemData.text}</div>`;
        },
        onCampaignSelected(campaign: any) {
            this.$nextTick(() => {
                this.selectedCampaign = JSON.parse(JSON.stringify(campaign));
                this.selectedIndex = 1;
            });
        },
        fetchCampaign(id: string) {
            const ds = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareCampaniiMarketing',
                    key: 'ID',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                        };
                        e.params.$expand = 'Industrie($select=Nume)';
                    },
                },
                filter: ['ID', '=', id],
            });

            ds.load().then((response) => {
                if (response && response.length > 0) {
                    this.selectedCampaign = response[0];
                    this.selectedIndex = 1;
                }
            }).catch(error => {
                console.error("Error fetching campaign:", error);
            });
        }
    }

});
</script>
<style scoped>
.tabs-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
